module.exports = require("@angular-devkit/core/node");